import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import DefaultOfferSettings from './DefaultOfferSettings';

export default function DefaultOfferSettingsPortal(){
  const [target,setTarget]=useState(null);
  useEffect(()=>{
    let frame;
    const find=()=>{
      const page=document.querySelector('.page-stack');
      if(page)setTarget(page);
      else frame=requestAnimationFrame(find);
    };
    find();
    return()=>frame&&cancelAnimationFrame(frame);
  },[]);
  if(!target)return null;
  return createPortal(<DefaultOfferSettings />,target);
}
